import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.025 3.017a2.65 2.65 0 0 1 1.864-.767H10.5c.698 0 1.369.275 1.864.767s.775 1.16.775 1.858V6.75a.75.75 0 0 1-1.5 0V4.875a1.12 1.12 0 0 0-.332-.794 1.15 1.15 0 0 0-.807-.331H3.889c-.304 0-.594.12-.807.331a1.12 1.12 0 0 0-.332.794v11.25c0 .297.119.582.332.794.213.211.503.331.807.331H10.5c.304 0 .594-.12.807-.331s.332-.497.332-.794V14.25a.75.75 0 0 1 1.5 0v1.875a2.62 2.62 0 0 1-.775 1.858 2.65 2.65 0 0 1-1.864.767H3.889a2.65 2.65 0 0 1-1.864-.767 2.62 2.62 0 0 1-.775-1.858V4.875c0-.698.28-1.366.775-1.858m13.61 4.142a.75.75 0 0 1 1.06-.004l2.833 2.813a.75.75 0 0 1 0 1.064l-2.833 2.813a.75.75 0 0 1-1.057-1.065l1.542-1.53H5.778a.75.75 0 0 1 0-1.5H17.18l-1.542-1.53a.75.75 0 0 1-.004-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }